/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';

import {debounceTime, distinctUntilChanged, takeUntil, tap} from 'rxjs/operators';

import {Destroyable} from '../../../destroyable.component';
import {CliEmpAttributes} from '../../../models/models.interfaces';
import {Data} from '../../api';
import {Team} from '../teams.model';

@Component({
  selector: 'gp-teams-filter',
  templateUrl: './teams-filter.component.html',
  styleUrls: ['./teams-filter.component.scss']
})
export class TeamsFilterComponent extends Destroyable implements OnInit, OnChanges {

  @Input()
  public isIframe: boolean = false;

  @Input()
  public employees: Array<Data<CliEmpAttributes>> = [];

  @Input()
  public userId: number;

  @Input()
  public teams: Team[] = [];

  @Input()
  public selectedTeam: number = 0;

  @Input()
  public isCustomTeam = false;

  @Output()
  onOpenCreateTeamModal: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  onChangeTeam: EventEmitter<Event> = new EventEmitter<Event>();

  @Output()
  onDeleteTeam: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  search: EventEmitter<string> = new EventEmitter<string>();
  public searchTermControl: UntypedFormControl = new UntypedFormControl('');
  public allCharsExceptSimpleQuoteGroupMaskPatterns = {
    L: {
      pattern: new RegExp(/[^']/)
    }
  };

  constructor() {
    super();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.isCustomTeam?.currentValue) {
      this.searchTermControl.setValue('');
      this.searchTermControl.disable();
    } else if (changes.isCustomTeam && !changes.isCustomTeam?.isFirstChange()) {
      this.searchTermControl.enable();
    }
  }

  public ngOnInit(): void {
    this.searchTermControl.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(value => {
          if (!value || value.length > 2) {
            this.search.emit(value);
          }
        }),
        takeUntil(this.componentDestroyed$),
      )
      .subscribe();
  }

  public openCreateTeamModal() {
    this.onOpenCreateTeamModal.emit();
  }

  public deleteTeam() {
    this.onDeleteTeam.emit();
  }

  public changeTeam(event) {
    this.onChangeTeam.emit(event);
  }

}
